var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ConnectedCarHeader'),(_vm.progress)?_c('ProgressIndicator'):_vm._e(),_c('router-view'),(_vm.dealer)?_c('DealerInfo'):_vm._e(),_c('ConnectedCarFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }